export { default as HomePage } from './home/HomePage';
export { default as WorkPage } from './work/WorkPage';
